module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/goldenpin_design_logo-b6b11aea08ed039ebf029e9e95ccb5e3.svg&quot;;"